// Exact icon path data from the CTT Skilling LMS Vite reference design,
// so rebuilt pages can match the reference icon-for-icon instead of approximating with MUI icons.
const ICON_PATHS: Record<string, string> = {
  grid: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  users: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2 20c0-3.5 3-6 7-6s7 2.5 7 6M17 12a3 3 0 1 0 0-6M18 20c0-2.5-1-4.3-2.5-5.3',
  book: 'M4 5a2 2 0 0 1 2-2h12v16H6a2 2 0 0 0-2 2zM8 3v14',
  doc: 'M6 3h9l3 3v15H6zM15 3v4h3M9 13h6M9 17h5',
  bank: 'M6 3h9l3 3v15H6zM15 3v4h3M9 12h6M9 16h4M9 8h3',
  clip: 'M9 4h6v3H9zM7 5H5v16h14V5h-2M9 12h6M9 16h6',
  check: 'M4 7h13M4 12h13M4 17h9M18 15l2 2 3-3',
  chat: 'M4 5h16v10H9l-4 4V5z',
  cal: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
  calchk: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4M9 15l2 2 4-4',
  handshake: 'M8 11 3 6l3-2 4 3h4l4-3 3 2-5 5M8 11l3 3 2-2 2 2 3-3M8 11l2 2',
  home: 'M3 11.5 12 4l9 7.5M5 10v9h5v-6h4v6h5v-9',
  help: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.9.4-1 .8-1 1.7M12 17h.01',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 20c0-4 3.5-6 8-6s8 2 8 6',
  logout: 'M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4M9 12h11M16 8l4 4-4 4',
  gear: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 13a7.5 7.5 0 0 0 0-2l2-1.5-2-3.4-2.4 1a7.5 7.5 0 0 0-1.7-1L14.9 3H9.1l-.4 2.6a7.5 7.5 0 0 0-1.7 1l-2.4-1-2 3.4L2.6 11a7.5 7.5 0 0 0 0 2l-2 1.5 2 3.4 2.4-1a7.5 7.5 0 0 0 1.7 1l.4 2.6h5.8l.4-2.6a7.5 7.5 0 0 0 1.7-1l2.4 1 2-3.4z',
  arr: 'M5 12h14M13 6l6 6-6 6',
  arrl: 'M19 12H5M11 6l-6 6 6 6',
  cv: 'M6 9l6 6 6-6',
  plus: 'M12 5v14M5 12h14',
  edit: 'M4 20h4L18 10l-4-4L4 16zM14 6l4 4',
  filter: 'M3 5h18l-7 8v6l-4-2v-4z',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM21 21l-4-4',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7.5V12l3 1.8',
  play: 'M8 5v14l11-7z',
  pdf: 'M6 3h9l3 3v15H6zM15 3v4h3M8 13h2a1.5 1.5 0 0 1 0 3H8zM8 13v6',
  video: 'M4 6h11v12H4zM15 10l5-3v10l-5-3',
  link: 'M9 15l6-6M8 12l-2 2a3 3 0 0 0 4 4l2-2M16 12l2-2a3 3 0 0 0-4-4l-2 2',
  sheet: 'M5 3h14v18H5zM5 9h14M5 15h14M11 3v18',
  slides: 'M4 4h16v12H4zM12 16v4M8 20h8',
  award: 'M12 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM8.5 13 7 21l5-2 5 2-1.5-8',
  star: 'M12 3l2.9 6 6.6.6-5 4.3 1.5 6.5L12 17.7 6 20.4l1.5-6.5-5-4.3 6.6-.6z',
  flag: 'M5 21V4M5 4c3-2 6 2 9 0s5 0 5 0v9s-2 2-5 0-6-2-9 0',
  alert: 'M10.3 3.9 2.7 17.2a2 2 0 0 0 1.7 3h15.2a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0zM12 9v4M12 17h.01',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v5M12 7.5h.01',
  x: 'M6 6l12 12M18 6L6 18',
  tick: 'M5 12l5 5 9-11',
  chip2: 'M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3M5 5h14v14H5zM9 9h6v6H9z',
  tool: 'M15 7a4 4 0 0 1-5.2 3.8L5 15.5 8.5 19l4.7-4.8A4 4 0 0 0 17 9l-2 2-2-2z',
  wifi: 'M2 8.5a15 15 0 0 1 20 0M5 12a10 10 0 0 1 14 0M8 15.5a5 5 0 0 1 8 0M12 19h.01',
  moon: 'M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z',
  sun: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 1v3M12 20v3M4 12H1M23 12h-3M5 5 3 3M21 21l-2-2M5 19l-2 2M21 3l-2 2',
  bell: 'M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6M10 20a2 2 0 0 0 4 0',
  loc: 'M12 21s7-6 7-11a7 7 0 1 0-14 0c0 5 7 11 7 11zM12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5',
};

export default ICON_PATHS;
